import Modal from "react-bootstrap/Modal";
import { IoMdClose } from "react-icons/io";
import CustomDatePickerRange from "../../component/ui/DatePickerRange";
import React, {
  Dispatch,
  MutableRefObject,
  SetStateAction,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { CmmnFn, fn_getCurrentDate } from "../../../helper/CmmnHelper";
import { getLoginUser } from "../../../helper/SecurityHelper";
import { Col, Container, ModalBody, Row, Table } from "react-bootstrap";
import BMCInput from "../../../components/common/BMCInput";
import BMCDatePicker from "../../../components/common/BMCDatePicker";
import BMCTextarea from "../../../components/common/BMCTextarea";
import axios from "axios";
import { toast } from "react-toastify";
import messageCodeDic from "../../../util/messageCodeDic";
import errorCodeDic from "../../../util/errorCodeDic";
import CmpnyCardList from "../../../components/cmpny/CmpnyCardList";
import restapi from "../../../helper/restAPIHelper";
import { validFormData, NUMBER } from "../../../helper/FormHelper";
import BMCSelect from "../../../components/common/BMCSelect";
import BMCFile from "../../../components/common/BMCFile";
import { map } from "react-bootstrap/ElementChildren";
import { ProgressContext } from "../../../context/Progress";
import BMCIconButton from "../../../components/common/BMCIconButton";
import IconRemove from "../../../images/icon_remove.png";
import WrkrSrchModal from "../../siteSafetyManagement/modal/WrkrSrchModal";
import MngrSrchModal from "./MngrSrchModal";
import CmpnySrchModal from "./CmpnySrchModal";
import iconNodata from "../../../images/icon_nodocdata.png";
import BMCRadio from "../../../components/common/BMCRadio";
import BMCRadioGroup from "../../../components/common/BMCRadioGroup";
import { Console } from "node:console";
import CustomDatePicker from '../../component/ui/DatePicker';

interface IProps {
  setModalIsOpen: Dispatch<SetStateAction<boolean>>;
  modalIsOpen: boolean;
  cnstrBaseInfoDtlData: any;
  setIsSaveSuccess?: Dispatch<SetStateAction<boolean>>;
}

const SiteManageRgstModal = (props: IProps) => {
  const prodRef = useRef<any>();
  const currentDate = fn_getCurrentDate();
  const user = getLoginUser();
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [isStartDatePopupOpen, setIsStartDatePopupOpen] = useState(false);
  const [isEndDatePopupOpen, setIsEndDatePopupOpen] = useState(false);
  const [cmpnyDataList, setCmpnyDataList] = useState<object[]>([]);
  const [data, setData] = useState<any>({});
  const formRef = React.createRef<HTMLFormElement>();
  const [fileList, setFileList] = useState([]);
  const [repFileSn, setRepFileSn] = useState<any>(null);
  const { spinner } = useContext(ProgressContext);
  const [headChrgrDataList, setHeadChrgrDataList] = useState<any>([]);
  const [siteChrgrDataList, setSiteChrgrDataList] = useState<any>([]);
  const [bldrDataList, setBldrDataList] = useState<any>([]);
  const [sprvDataList, setSprvDataList] = useState<any>([]);
  const [drctDataList, setDrctDataList] = useState<any>([]);
  const [coprDataList, setCoprDataList] = useState<any>([]);
  const [isMngrModalOpen, setIsMngrModalOpen] = useState<boolean>(false);
  const [cmpnySeq, setCmpnySeq] = useState<any>(null);
  const [mngrDataList, setMngrDataList] = useState<any>([]);
  const [headCmpnyInfo, setHeadCmpnyInfo] = useState<any>(null);
  const [companyGbCd, setCompanyGbCd] = useState<any>(null);
  const [isCmpnyModalOpen, setIsCmpnyModalOpen] = useState<boolean>(false);
  const [dprtCd, setDprtCd] = useState<string>("");
  const mapRef = useRef<any>();
  const markerRef = useRef<any>();
  const placeRef = useRef<any>();
  const geocoderRef = useRef<any>();
  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    restapi.retrieveHeadCmpnyInfo().then((rsltData) => {
      setHeadCmpnyInfo(rsltData);
      console.log("headerInfo: ", rsltData);
    });
  }, []);

  useEffect(() => {
    // 본사
    if (companyGbCd == "C001001") {
      console.log("mngrDataList: ", mngrDataList);
      setHeadChrgrDataList(mngrDataList);
    }
  }, [mngrDataList]);

  useEffect(() => {
    // 시공사
    if (companyGbCd == "C001002") {
      console.log("cmpnyDataList: ", cmpnyDataList);
      setBldrDataList(cmpnyDataList);
      // 감리
    } else if (companyGbCd == "C001003") {
      setSprvDataList(cmpnyDataList);
      // 직영
    } else if (companyGbCd == "C001004") {
      setDrctDataList(cmpnyDataList);
    } else if (companyGbCd == "C001005") {
      setCoprDataList(cmpnyDataList);
    }
  }, [cmpnyDataList]);

  useEffect(() => {
    console.log("repFileSn: ", repFileSn);
  }, [repFileSn]);

  useEffect(() => {
    // 신규
  }, [props.cnstrBaseInfoDtlData]);

  function afterOpenModal() {
    if (!props.cnstrBaseInfoDtlData) {
      setStartDate("");
      setEndDate("");
      setData(null);
      setCmpnyDataList([]);
      setMngrDataList([]);
      setHeadChrgrDataList([]);
      setBldrDataList([]);
      setSprvDataList([]);
      setDrctDataList([]);
      setCoprDataList([]);
      setSiteChrgrDataList([]);
      setFileList([]);
      // 상세
    } else {
      setData(props.cnstrBaseInfoDtlData);
      setStartDate(props.cnstrBaseInfoDtlData.constructionStartDate);
      setEndDate(props.cnstrBaseInfoDtlData.constructionEndDate);
      if (props.cnstrBaseInfoDtlData.atchFileId) {
        restapi
          .retrieveAttachInfoList({
            attachSeq: props.cnstrBaseInfoDtlData.atchFileId,
          })
          .then((rsltData: any) => {
            if (
              props.cnstrBaseInfoDtlData?.repPhotoSn !== null &&
              props.cnstrBaseInfoDtlData?.repPhotoSn !== undefined
            ) {
              rsltData.map((data: any, idx: number) => {
                if (data.sn == props.cnstrBaseInfoDtlData.repPhotoSn) {
                  data.isRep = true;
                  setRepFileSn(idx);
                }
              });
            }

            setFileList([].concat(rsltData));
          });
      } else {
        setFileList([]);
      }

      restapi
        .retrieveHeadSiteMstrUserDataList({
          siteId: props.cnstrBaseInfoDtlData.siteId,
        })
        .then((rsltData: any) => {
          console.log("테스트============", props.cnstrBaseInfoDtlData.siteId);
          const bldrDataList = rsltData.bldrDataList;
          const headChrgrDataList = rsltData.headChrgrDataList;
          const siteChrgrDataList = rsltData.siteChrgrDataList;
          const sprvDataList = rsltData.sprvDataList;
          const drctDataList = rsltData.drctDataList;
          const coprDataList = rsltData.coprDataList;
          setHeadChrgrDataList(headChrgrDataList);
          setSiteChrgrDataList(siteChrgrDataList);
          setBldrDataList(bldrDataList);
          setSprvDataList(sprvDataList);
          setDrctDataList(drctDataList);
          setCoprDataList(coprDataList);
        });
    }
    // references are now sync'd and can be accessed.
    //   subtitleRef.current.style.color = '#f00';
  }

  function fn_closeModal() {
    props.setModalIsOpen(false);
  }

  const fn_startDatePopupOpen = () => {
    setIsStartDatePopupOpen(!isStartDatePopupOpen);
    setIsEndDatePopupOpen(false);
  };
  const fn_endDatePopupOpen = () => {
    setIsEndDatePopupOpen(!isEndDatePopupOpen);
    setIsStartDatePopupOpen(false);
  };

  const fn_initMap = () => {
    const container = document.getElementById("siteMap");
    if (!container) return;
    // @ts-ignore
    const lat = data?.latitude || 35.156022541877455;
    const lng = data?.longitude || 129.05158697091977;
    // @ts-ignore
    const center = new kakao.maps.LatLng(lat, lng);
    // @ts-ignore
    const option = {
      center: center,
      level: 3
    };
    // @ts-ignore
    mapRef.current = new kakao.maps.Map(
      container,
      option
    );
    // @ts-ignore
    markerRef.current = new kakao.maps.Marker({
      position: center
    });
    // @ts-ignore
    geocoderRef.current = new kakao.maps.services.Geocoder();
    markerRef.current.setMap(mapRef.current);
    // @ts-ignore
    placeRef.current = new kakao.maps.services.Places(mapRef.current);
    // @ts-ignore
    kakao.maps.event.addListener(
      mapRef.current,
      "click",
      function(mouseEvent:any) {
        const latlng = mouseEvent.latLng;
        markerRef.current.setPosition(latlng);
        geocoderRef.current.coord2Address(
          latlng.getLng(),
          latlng.getLat(),
          function(result:any, status:any){
            // @ts-ignore
            if(status !== kakao.maps.services.Status.OK){
              return;
            }
            const address =
              result[0].road_address?.address_name ??
              result[0].address.address_name;
            geocoderRef.current.coord2RegionCode(
              latlng.getLng(),
              latlng.getLat(),
              function (regionResult: any, regionStatus: any) {
                // @ts-ignore
                if (regionStatus !== kakao.maps.services.Status.OK) {
                  return;
                }
                const bjd = regionResult.find(
                  (item: any) => item.region_type === "B"
                );
                const bjdCode = bjd?.code ?? "";
                setData((prev: any) => ({
                  ...prev,
                  siteAddress: address,
                  bjdCode: bjdCode,
                  longitude: latlng.getLng(),
                  latitude: latlng.getLat()
                }));
              }
            );
          }
        );
      }
    );
  };

  const fn_searchAddress = () => {
    if (!keyword.trim()) return;
    // @ts-ignore
    const geocoder = new kakao.maps.services.Geocoder();
    geocoder.addressSearch(keyword, function (result:any, status:any) {
      // @ts-ignore
      if (status === kakao.maps.services.Status.OK) {
        const latlng =
          // @ts-ignore
          new kakao.maps.LatLng(
            result[0].y,
            result[0].x
          );
        mapRef.current.setCenter(latlng);
        markerRef.current.setPosition(latlng);
        return;
      }
      if (!placeRef.current) {
        // @ts-ignore
        placeRef.current = new kakao.maps.services.Places(mapRef.current);
      }
      placeRef.current.keywordSearch(
        keyword,
        fn_placeSearchCallback
      );
    });
  };

  const fn_placeSearchCallback = (
    result:any,
    status:any
  ) => {
    // @ts-ignore
    if (status !== kakao.maps.services.Status.OK) {
      alert("검색 결과가 없습니다.");
      return;
    }
    const latlng =
      // @ts-ignore
      new kakao.maps.LatLng(
        result[0].y,
        result[0].x
      );
    mapRef.current.setCenter(latlng);
    markerRef.current.setPosition(latlng);
  };

  const fn_setFormData = (e: any) => {
    if (e.target.name == "cnstrPrice") {
      if (e.target.value) {
        e.target.value = parseInt(
          e.target.value.replaceAll(",", "")
        ).toLocaleString();
      }
    }

    let value: any = e.target.value;

    if (e.target.type == "radio" && typeof e.target.value == "string") {
      value = e.target.value === "true";
    }

    setData({
      ...data,
      [e.target.name]: value,
    });
  };

  const fn_registData = () => {
    if (!data) {
      toast.warn("데이터를 입력해 주십시오.");
      return;
    }

    if (!data.isSmSite) {
      if (!data.siteName) {
        toast.warn("현장명을 입력해 주십시오.");
        return;
      }

      if (!data.siteType) {
        toast.warn("공종을 선택해 주십시오.");
        return;
      }

      if (!data.cnstrPrice) {
        toast.warn("공사금액을 입력해 주십시오.");
        return;
      }

      if (!data.siteAddress) {
        toast.warn("주소를 입력해 주십시오.");
        return;
      }

      if (!startDate || !endDate) {
        toast.warn("공사기간을 입력해 주십시오.");
        return;
      }

      if (data.siteType === "T002004" && !data.fcltyGbCd) {
        toast.warn("시설구분을 선택해 주십시오.");
        return;
      }

      data.constructionStartDate = startDate;
      data.constructionEndDate = endDate;
      if (typeof data.cnstrPrice != "number") {
        data.cnstrPrice = data.cnstrPrice.replace(/,/g, "");
      }
    }

    let param: any = data;

    param.headChrgrDataList = headChrgrDataList;
    param.bldrDataList = bldrDataList;
    param.sprvDataList = sprvDataList;
    param.drctDataList = drctDataList;
    param.coprDataList = coprDataList;
    param.siteChrgrDataList = siteChrgrDataList;
    param.regSeq = user.userSeq;
    param.updateSeq = user.userSeq;

    console.log("param: ", param);
    // @ts-ignore
    var formData: any = new FormData(formRef.current);

    if (fileList.length > 0 && repFileSn === null) {
      toast.warn("대표 현장사진을 선택해 주십시오");
      return;
    }

    if (fileList.length > 0) {
      param.repFileSn = repFileSn;
      for (var i = 0; i < fileList.length; i++) {
        formData.append("atchFileList", fileList[i]);
      }
    }

    console.log("fileList: ", fileList);
    console.log("param: ", param);
    console.log(123, formData.get("atchFileList"));

    /*        formData.set('longitude', data.longitude);
                formData.set('latitude', data.latitude);*/

    formData.set(
      "siteInfo",
      new Blob([JSON.stringify(param)], { type: "application/json" })
    );

    if (!window.confirm("저장 하시겠습니까?")) {
      return;
    }

    spinner.start();
    axios
      .post("/admin/api/site/saveHeadSiteData", formData)
      .then((result) => {
        if (result.data > 0) {
          toast.success(messageCodeDic["001"]);
          props.setModalIsOpen(false);
          if (props.setIsSaveSuccess) {
            props.setIsSaveSuccess(true);
          }
        } else {
          toast.error(errorCodeDic["003"]);
          if (props.setIsSaveSuccess) {
            props.setIsSaveSuccess(false);
          }
        }
      })
      .catch((error) => {
        toast.error(errorCodeDic["003"]);
        console.log("error: ", error);
      })
      .finally(() => {
        spinner.stop();
      });
  };

  const fn_headChrgrModalOpen = () => {
    if (!data || !data.dprtCd) {
      toast.warn("우선 부서를 선택해 주십시오.");
      return;
    }

    setDprtCd(data.dprtCd);

    setCmpnySeq(headCmpnyInfo.companySeq);
    setCompanyGbCd("C001001");
    setIsMngrModalOpen(true);
    setMngrDataList(headChrgrDataList);
  };

  const fn_openMngrModal = (cmpnySeq: number, companyGbCd: string) => {
    setCmpnySeq(cmpnySeq);
    setCompanyGbCd(companyGbCd);
    setIsMngrModalOpen(true);
    setDprtCd("");
    setMngrDataList(siteChrgrDataList);
  };

  const fn_delChrgrDataRow = (idx: number) => {
    headChrgrDataList.splice(idx, 1);
    setHeadChrgrDataList([].concat(headChrgrDataList));
  };

  const fn_cmpnyModalOpen = (companyGbCd: string) => {
    setCompanyGbCd(companyGbCd);
    setIsCmpnyModalOpen(true);
    // 시공사
    if (companyGbCd == "C001002") {
      setCmpnyDataList(bldrDataList);
      // 감리
    } else if (companyGbCd == "C001003") {
      setCmpnyDataList(sprvDataList);
      // 직영
    } else if (companyGbCd == "C001004") {
      setCmpnyDataList(drctDataList);
      // 협력업체
    } else if (companyGbCd == "C001005") {
      setCmpnyDataList(coprDataList);
    }
  };

  const fn_delSiteChrgrDataRow = (userSeq: number) => {
    console.log("userSeq: ", userSeq);
    const cstmSiteChrgrDataList = siteChrgrDataList.filter(
      (data: any) => data.userSeq != userSeq
    );
    setSiteChrgrDataList(cstmSiteChrgrDataList);
  };

  const fn_deleteCmpnyData = (companySeq: number, cmpnyGb: string) => {
    const cstmSiteChrgrDataList = siteChrgrDataList.filter(
      (data: any) => data.blngCmpnySeq != companySeq
    );

    let cstmCmpnyDataList;

    if (cmpnyGb == "C001002") {
      cstmCmpnyDataList = bldrDataList.filter(
        (data: any) => data.companySeq != companySeq
      );
    } else if (cmpnyGb == "C001003") {
      cstmCmpnyDataList = sprvDataList.filter(
        (data: any) => data.companySeq != companySeq
      );
    } else if (cmpnyGb == "C001004") {
      cstmCmpnyDataList = drctDataList.filter(
        (data: any) => data.companySeq != companySeq
      );
    } else if (cmpnyGb == "C001005") {
      cstmCmpnyDataList = coprDataList.filter(
        (data: any) => data.companySeq != companySeq
      );
    }

    setSiteChrgrDataList(cstmSiteChrgrDataList);
    setCompanyGbCd(cmpnyGb);
    setCmpnyDataList(cstmCmpnyDataList);
  };

  return (
    <div>
      <MngrSrchModal
        setModalIsOpen={setIsMngrModalOpen}
        modalIsOpen={isMngrModalOpen}
        mngrDataList={mngrDataList}
        setMngrDataList={setMngrDataList}
        cmpnySeq={cmpnySeq}
        companyGbCd={companyGbCd}
        dprtCd={dprtCd}
      />
      <CmpnySrchModal
        setModalIsOpen={setIsCmpnyModalOpen}
        modalIsOpen={isCmpnyModalOpen}
        cmpnyDataList={cmpnyDataList}
        setCmpnyDataList={setCmpnyDataList}
        companyGbCd={companyGbCd}
      />

      <Modal
        onShow={afterOpenModal}
        onEntered={()=>{
          setKeyword("");
          setTimeout(()=>{
              fn_initMap();
          },300);
        }}
        className="bmc-modal"
        size="xl"
        show={props.modalIsOpen}
        onHide={fn_closeModal}
      >
        <Modal.Header>
          <div className="d-flex justify-content-between align-items-center w-100 bmc-font-SD">
            현장 등록/수정
            <IoMdClose
              className="hover:cursor-pointer"
              onClick={fn_closeModal}
            />
          </div>
        </Modal.Header>
        <Modal.Body className="px-4">
          <form
            name={"noticeDetailForm"}
            ref={formRef}
            encType="multipart/form-data"
            method={"post"}
          >
            <BMCInput
              type={"hidden"}
              value={data?.atchFileId}
              name={"atchFileId"}
            ></BMCInput>
            <BMCInput
              type={"hidden"}
              value={data?.siteId}
              name={"siteId"}
            ></BMCInput>
            <div className="bmc-modal-div">
              <div className="div-header">공사 기본정보</div>

              <div className="div-body px-3">
                <Table className="my-2 align-middle">
                  {data?.isSmSite ? (
                    <tbody>
                      <tr className="border-top align-middle">
                        <th className="bmc-bg-th" style={{ width: "15%" }}>
                          현장명
                        </th>
                        <td style={{ width: "75%" }}>
                          <BMCInput
                            name={"siteName"}
                            readOnly={true}
                            value={data?.siteName}
                            onChange={fn_setFormData}
                            className="form-control"
                          />
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      <tr className="border-top align-middle">
                        <th className="bmc-bg-th" style={{ width: "12%" }}>
                          현장명
                        </th>
                        <td style={{ width: "38%" }}>
                          <BMCInput
                            name={"siteName"}
                            value={data?.siteName}
                            onChange={fn_setFormData}
                            className="form-control"
                          />
                        </td>
                        <th className="bmc-bg-th" style={{ width: "12%" }}>
                          공사기간
                        </th>
                        <td style={{ width: "38%" }}>
                          <div
                            className="d-flex align-items-center w-100"
                            ref={prodRef}
                          >
                            <BMCDatePicker
                              className={"text-center"}
                              readOnly={true}
                              value={startDate}
                              name={"constructionStartDate"}
                              onClick={fn_startDatePopupOpen}
                              onChange={fn_setFormData}
                              calendar={fn_startDatePopupOpen}
                            />
                            <span className="flex-grow-1 text-center">
                              &nbsp;~&nbsp;
                            </span>
                            <BMCDatePicker
                              readOnly={true}
                              className={"text-center"}
                              value={endDate}
                              name={"constructionEndDate"}
                              onClick={fn_endDatePopupOpen}
                              onChange={fn_setFormData}
                              calendar={fn_endDatePopupOpen}
                            />

                            {isStartDatePopupOpen ? (
                              <CustomDatePicker
                                setIsDatePopupOpen={setIsStartDatePopupOpen}
                                prodRef={prodRef}
                                setDateView={setStartDate}
                                zIndex={2}
                              />
                            ) : null}
                            {isEndDatePopupOpen ? (
                              <CustomDatePicker
                                setIsDatePopupOpen={setIsEndDatePopupOpen}
                                prodRef={prodRef}
                                setDateView={setEndDate}
                                zIndex={2}
                              />
                            ) : null}
                          </div>
                        </td>
                      </tr>
                      <tr className="border-top align-middle">
                        <th className="bmc-bg-th">공종</th>
                        <td>
                          <BMCSelect
                            initOptionGb={"sel"}
                            className={"bmc-select"}
                            codeGb={"cmmn"}
                            codeGrpId={"T002"}
                            name={"siteType"}
                            onChange={fn_setFormData}
                            value={data?.siteType}
                          ></BMCSelect>
                        </td>
                        <th className="bmc-bg-th">공사금액</th>
                        <td>
                          <div className="d-flex align-items-center px-0 gap-1">
                            <BMCInput
                              type="text"
                              className="text-right form-control"
                              name={"cnstrPrice"}
                              onChange={fn_setFormData}
                              value={data?.cnstrPrice?.toLocaleString()}
                            />
                            <span>원</span>
                          </div>
                        </td>
                      </tr>

                      <tr className="border-top align-middle">
                        <th className="bmc-bg-th">위치 선택</th>
                        <td colSpan={3}>
                          <div className="d-flex flex-column w-100">
                            <div className="d-flex align-items-center mb-2">
                              <BMCInput
                                type="text"
                                className="form-control"
                                value={keyword}
                                onChange={(e:any)=>setKeyword(e.target.value)}
                                placeholder="도로명주소를 입력하세요"
                              />
                              <button
                                className="bmc-btn btn-secondary min-w-70 ml-5 mr-10"
                                type="button"
                                onClick={fn_searchAddress}
                              >
                                검색
                              </button>
                            </div>
                            <div
                              id="siteMap"
                              style={{
                                  width: "100%",
                                  height: "400px",
                                  border: "1px solid #dee2e6",
                                  borderRadius: "6px",
                                  position: "relative",
                                  zIndex: 1
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                      <tr className="border-top align-middle">
                        <th className="bmc-bg-th">주소</th>
                        <td colSpan={3}>
                          <div className="d-flex align-items-center justify-content-between w-100 p-0 bmc-fs-b3">
                            <BMCInput
                              type="text"
                              name={"siteAddress"}
                              value={data?.siteAddress}
                              className="form-control"
                              readOnly
                            />
                            <span className="min-w-40 ml-10">경도</span>
                            <BMCInput
                              type="text"
                              className="w-100_20250522 form-control"
                              name={"longitude"}
                              value={data?.longitude}
                              disabled={true}
                            />
                            <span className="min-w-40 ml-10">위도</span>
                            <BMCInput
                              type="text"
                              className="w-100_20250522 form-control"
                              name={"latitude"}
                              value={data?.latitude}
                              disabled={true}
                            />
                          </div>
                        </td>
                      </tr>
                      <tr className="border-top align-middle">
                        <th className="bmc-bg-th">상세주소</th>
                        <td>
                          <div className="d-flex align-items-center px-0">
                            <BMCInput
                              type="text"
                              className={"form-control"}
                              onChange={fn_setFormData}
                              name={"siteDtlAddress"}
                              value={data?.siteDtlAddress}
                            />
                          </div>
                        </td>
                        <th className="bmc-bg-th" style={{ width: "15%" }}>
                          부서
                        </th>
                        <td style={{ width: "35%" }}>
                          <BMCSelect
                            initOptionGb={"sel"}
                            name={"dprtCd"}
                            codeGrpId={"D001"}
                            className={"w-100"}
                            codeGb={"cmmn"}
                            onChange={fn_setFormData}
                            value={data?.dprtCd}
                          ></BMCSelect>
                        </td>
                      </tr>
                      <tr className="border-top align-middle">
                        <th className="bmc-bg-th">사업유형</th>
                        <td>
                          <div className="d-flex align-items-center px-0">
                            <BMCSelect
                              initOptionGb={"sel"}
                              name={"bsnsTpCd"}
                              codeGrpId={"B002"}
                              className={"w-100"}
                              codeGb={"cmmn"}
                              onChange={fn_setFormData}
                              value={data?.bsnsTpCd}
                            ></BMCSelect>
                          </div>
                        </td>
                        {data?.siteType == "T002004" ? (
                          <>
                            <th className="bmc-bg-th" style={{ width: "15%" }}>
                              시설구분
                            </th>
                            <td style={{ width: "35%" }}>
                              <div className="d-flex align-items-center px-0">
                                <BMCSelect
                                  initOptionGb={"sel"}
                                  name={"fcltyGbCd"}
                                  codeGrpId={"F001"}
                                  className={"w-100"}
                                  codeGb={"cmmn"}
                                  onChange={fn_setFormData}
                                  value={data?.fcltyGbCd}
                                ></BMCSelect>
                              </div>
                            </td>
                          </>
                        ) : (
                          data?.siteType == "T002003" && (
                            <>
                              <th
                                className="bmc-bg-th"
                                style={{ width: "15%" }}
                              >
                                지도표출 여부
                              </th>
                              <td style={{ width: "35%" }}>
                                <div className="d-flex align-items-center px-0">
                                  <BMCRadioGroup>
                                    <BMCRadio
                                      name={"isShowOnMap"}
                                      value={true}
                                      checked={data.isShowOnMap}
                                      onClick={fn_setFormData}
                                      onChange={() => null}
                                    >
                                      <span>예</span>
                                    </BMCRadio>
                                    <BMCRadio
                                      name={"isShowOnMap"}
                                      className={"ml-10"}
                                      value={false}
                                      checked={!data.isShowOnMap}
                                      onClick={fn_setFormData}
                                      onChange={() => null}
                                    >
                                      <span>아니오</span>
                                    </BMCRadio>
                                  </BMCRadioGroup>
                                </div>
                              </td>
                            </>
                          )
                        )}
                      </tr>

                      {/*<tr className="border-top align-middle">
                                        <th className="bmc-bg-th">
                                            공사내용
                                        </th>
                                        <td colSpan={3}>
                                            <div className="d-flex align-items-center px-0">
                                                <BMCTextarea className="form-control" name={'cnstrCntnts'}
                                                            onChange={fn_setFormData}
                                                            value={data?.cnstrCntnts} placeholder="공사내용을 입력해주세요."
                                                            rows={5}></BMCTextarea>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="bmc-bg-th">
                                            현장사진
                                        </th>
                                        <td colSpan={3}>
                                            <BMCFile fileName={'photos'} fileList={fileList} setFileList={setFileList}
                                                    repFileSn={repFileSn} setRepFileSn={setRepFileSn}></BMCFile>

                                        </td>
                                    </tr>*/}
                    </tbody>
                  )}
                </Table>
              </div>
            </div>

            {!data?.isSmSite && (
              <div className="bmc-modal-div">
                <div className="div-header">
                  <div>BMC공사 본사정보</div>
                  <BMCIconButton kind={"add"} onClick={fn_headChrgrModalOpen}>
                    추가
                  </BMCIconButton>
                </div>
                <div className="div-body px-3">
                  <Table className="sub my-2 text-center">
                    <thead>
                      <tr className="table-secondary">
                        <th className="align-middle w-10per">No</th>
                        <th className="align-middle w-20per">담당자</th>
                        <th className="align-middle w-30per">소속 부서</th>
                        <th className="align-middle w-30per">전화번호</th>
                        <th className="align-middle w-10per">삭제</th>
                      </tr>
                    </thead>
                    <tbody id="wrkDclrRgst_siteTBody">
                      {headChrgrDataList.length > 0 ? (
                        headChrgrDataList.map((data: any, idx: number) => (
                          <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td className={"align-content-start"}>
                              {data.userName}
                            </td>
                            <td className={"align-content-start"}>
                              {data.dprtNm}
                            </td>
                            <td className={"align-middle"}>
                              {data.userPhoneReg}
                            </td>
                            <td>
                              <img
                                className="w-25_250522 cursor-pointer inline-block"
                                src={IconRemove}
                                onClick={() => {
                                  fn_delChrgrDataRow(idx);
                                }}
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={5}>
                            <div className="text-center">
                              등록된 담당자가 없습니다.
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            )}

            <div className="bmc-modal-div">
              <div className="div-header">
                <div>{data?.isSmSite ? "센터업체 정보" : "시공사 정보"}</div>
                <BMCIconButton
                  kind={"add"}
                  onClick={() => fn_cmpnyModalOpen("C001002")}
                >
                  추가
                </BMCIconButton>
              </div>
              <div className="div-body px-3">
                {bldrDataList.length > 0 ? (
                  bldrDataList.map((bldrData: any, idx: number) => (
                    <Container className="bmc-box-form py-2 mt-2" key={idx}>
                      <Row className="font-semibold">
                        <div className="d-flex justify-content-between align-items-center w-100 bmc-font-SD mb-2">
                          {"시공사 " + (idx + 1)}
                          <BMCIconButton
                            kind={"delete"}
                            onClick={() =>
                              fn_deleteCmpnyData(bldrData.companySeq, "C001002")
                            }
                          >
                            삭제
                          </BMCIconButton>
                        </div>
                      </Row>
                      <hr />
                      <Row className="mt-1 mb-2">
                        <Col>
                          <span className="bmc-fw-5">회사명</span>
                          <BMCInput
                            className="bmc-form input text-center"
                            value={bldrData.companyName}
                            disabled={true}
                          />
                        </Col>
                        <Col>
                          <span className="bmc-fw-5">대표전화</span>
                          <BMCInput
                            className="bmc-form input text-center"
                            value={bldrData.contactPhoneNo}
                            disabled={true}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <div className="div-body-borderless border-none">
                          <div className="w-100 d-flex justify-content-end align-items-center mb-2">
                            <BMCIconButton
                              kind={"add"}
                              onClick={() =>
                                fn_openMngrModal(bldrData.companySeq, "C001002")
                              }
                            >
                              행추가
                            </BMCIconButton>
                          </div>

                          <Table className="sub my-2 text-center">
                            <thead>
                              <tr className="table-secondary">
                                <th className="align-middle w-10per">No</th>
                                <th className="align-middle w-20per">직위</th>
                                <th className="align-middle w-20per">이름</th>
                                <th className="align-middle w-20per">핸드폰</th>
                                <th className="align-middle w-20per">이메일</th>
                                <th className="align-middle w-10per">삭제</th>
                              </tr>
                            </thead>
                            <tbody>
                              {siteChrgrDataList.filter(
                                (data: any) =>
                                  bldrData.companySeq == data.blngCmpnySeq
                              ).length > 0 ? (
                                siteChrgrDataList.map(
                                  (data: any, idx: number) =>
                                    bldrData.companySeq ==
                                      data.blngCmpnySeq && (
                                      <tr key={idx}>
                                        <td>{idx + 1}</td>
                                        <td className={"align-content-start"}>
                                          {data.position}
                                        </td>
                                        <td className={"align-content-start"}>
                                          {data.userName}
                                        </td>
                                        <td className={"align-middle"}>
                                          {data.userPhoneReg}
                                        </td>
                                        <td className={"align-middle"}>
                                          {data.userEmail}
                                        </td>
                                        <td>
                                          <img
                                            className={
                                              "w-25_250522 cursor-pointer inline-block"
                                            }
                                            src={IconRemove}
                                            onClick={() => {
                                              fn_delSiteChrgrDataRow(
                                                data.userSeq
                                              );
                                            }}
                                          />
                                        </td>
                                      </tr>
                                    )
                                )
                              ) : (
                                <tr>
                                  <td colSpan={5}>
                                    <div className="text-center">
                                      등록된 담당자가 없습니다.
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </Row>
                    </Container>
                  ))
                ) : (
                  <div className="w-100 justify-content-center d-flex flex-column align-items-center py-2">
                    <img
                      src={iconNodata}
                      alt="이미지"
                      style={{ width: "70px" }}
                    />
                    <span className="bmc-text-font_secondary02 bmc-fw-5 mt-2">
                      등록된 시공사가 없습니다.
                    </span>
                  </div>
                )}
              </div>
            </div>
            {!data?.isSmSite && (
              <div className="bmc-modal-div">
                <div className="div-header">
                  <div>사업감리단 정보</div>
                  <BMCIconButton
                    kind={"add"}
                    onClick={() => fn_cmpnyModalOpen("C001003")}
                  >
                    추가
                  </BMCIconButton>
                </div>
                <div className="div-body px-3">
                  {sprvDataList.length > 0 ? (
                    sprvDataList.map((sprvData: any, idx: number) => (
                      <Container className="bmc-box-form py-2 mt-2" key={idx}>
                        <Row className="font-semibold">
                          <div className="d-flex justify-content-between align-items-center w-100 bmc-font-SD mb-2">
                            {"감리 " + (idx + 1)}
                            <BMCIconButton
                              kind={"delete"}
                              onClick={() =>
                                fn_deleteCmpnyData(
                                  sprvData.companySeq,
                                  "C001003"
                                )
                              }
                            >
                              삭제
                            </BMCIconButton>
                          </div>
                        </Row>
                        <hr />
                        <Row className="mt-1 mb-2">
                          <Col>
                            <span className="bmc-fw-5">회사명</span>
                            <BMCInput
                              className="bmc-form input text-center"
                              value={sprvData.companyName}
                              disabled={true}
                            />
                          </Col>
                          <Col>
                            <span className="bmc-fw-5">대표전화</span>
                            <BMCInput
                              className="bmc-form input text-center"
                              value={sprvData.contactPhoneNo}
                              disabled={true}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <div className="div-body">
                            <div className="w-100 d-flex justify-content-end align-items-center mb-2">
                              <BMCIconButton
                                kind={"add"}
                                onClick={() =>
                                  fn_openMngrModal(
                                    sprvData.companySeq,
                                    "C001003"
                                  )
                                }
                              >
                                행추가
                              </BMCIconButton>
                            </div>
                            <Table className="sub my-2 text-center">
                              <thead>
                                <tr className="table-secondary">
                                  <th className="align-middle w-10per">No</th>
                                  <th className="align-middle w-20per">직위</th>
                                  <th className="align-middle w-20per">이름</th>
                                  <th className="align-middle w-20per">
                                    핸드폰
                                  </th>
                                  <th className="align-middle w-20per">
                                    이메일
                                  </th>
                                  <th className="align-middle w-10per">삭제</th>
                                </tr>
                              </thead>
                              <tbody id="wrkDclrRgst_siteTBody">
                                {siteChrgrDataList.filter(
                                  (data: any) =>
                                    sprvData.companySeq == data.blngCmpnySeq
                                ).length > 0 ? (
                                  siteChrgrDataList.map(
                                    (data: any, idx: number) =>
                                      sprvData.companySeq ==
                                        data.blngCmpnySeq && (
                                        <tr key={idx}>
                                          <td>{idx + 1}</td>
                                          <td className={"align-content-start"}>
                                            {data.position}
                                          </td>
                                          <td className={"align-content-start"}>
                                            {data.userName}
                                          </td>
                                          <td className={"align-middle"}>
                                            {data.userPhoneReg}
                                          </td>
                                          <td className={"align-middle"}>
                                            {data.userEmail}
                                          </td>
                                          <td>
                                            <img
                                              className={
                                                "w-25_250522 cursor-pointer inline-block"
                                              }
                                              src={IconRemove}
                                              onClick={() => {
                                                fn_delSiteChrgrDataRow(
                                                  data.userSeq
                                                );
                                              }}
                                            />
                                          </td>
                                        </tr>
                                      )
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan={5}>
                                      <div className="text-center">
                                        등록된 담당자가 없습니다.
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </div>
                        </Row>
                      </Container>
                    ))
                  ) : (
                    <div className="w-100 justify-content-center d-flex flex-column align-items-center py-2">
                      <img
                        src={iconNodata}
                        alt="이미지"
                        style={{ width: "70px" }}
                      />
                      <span className="bmc-text-font_secondary02 bmc-fw-5 mt-2">
                        등록된 감리단이 없습니다.
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/*<div className="bmc-modal-div">
                            <div className="div-header">
                                <div>직영 정보</div>
                                <BMCIconButton kind={'add'}
                                              onClick={() => fn_cmpnyModalOpen('C001004')}>추가</BMCIconButton>
                            </div>
                            <div className="div-body px-3">
                                {
                                    drctDataList.length > 0 ?
                                        drctDataList.map((drctData: any, idx: number) => (

                                            <Container className='bmc-box-form py-2 mt-2' key={idx}>
                                                <Row className="font-semibold">
                                                    <div
                                                        className="d-flex justify-content-between align-items-center w-100 bmc-font-SD mb-2">
                                                        {'직영 ' + (idx + 1)}
                                                        <BMCIconButton kind={'delete'} onClick={() => fn_deleteCmpnyData(drctData.companySeq, 'C001004')}>삭제</BMCIconButton>
                                                    </div>
                                                </Row>
                                                <hr/>
                                                <Row className="mt-1 mb-2">
                                                    <Col>
                                                        <span className="bmc-fw-5">회사명</span>
                                                        <BMCInput className="bmc-form input text-center"
                                                                 value={drctData.companyName}
                                                                 disabled={true}/>
                                                    </Col>
                                                    <Col>
                                                        <span className="bmc-fw-5">대표전화</span>
                                                        <BMCInput className="bmc-form input text-center"
                                                                 value={drctData.contactPhoneNo}
                                                                 disabled={true}/>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <div className="div-body">
                                                        <div
                                                            className='w-100 d-flex justify-content-end align-items-center mb-2'>
                                                            <BMCIconButton kind={'add'} onClick={() => fn_openMngrModal(drctData.companySeq, 'C001004')}>행추가</BMCIconButton>
                                                        </div>
                                                        <Table className="sub my-2 text-center">
                                                            <thead>
                                                            <tr className="table-secondary">
                                                                <th className="align-middle w-[10%]">No</th>
                                                                <th className="align-middle w-[20%]">직위</th>
                                                                <th className="align-middle w-[20%]">이름</th>
                                                                <th className="align-middle w-[20%]">핸드폰</th>
                                                                <th className="align-middle w-[20%]">이메일</th>
                                                                <th className="align-middle w-[10%]">삭제</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody id="wrkDclrRgst_siteTBody">
                                                            {
                                                                siteChrgrDataList.filter((data: any) => (drctData.companySeq == data.blngCmpnySeq)).length > 0 ?
                                                                    siteChrgrDataList.map((data: any, idx: number) => (
                                                                        drctData.companySeq == data.blngCmpnySeq &&
                                                                        <tr key={idx}>
                                                                            <td>{idx + 1}</td>
                                                                            <td className={'align-content-start'}>
                                                                                {data.position}
                                                                            </td>
                                                                            <td className={'align-content-start'}>
                                                                                {data.userName}
                                                                            </td>
                                                                            <td className={'align-middle'}>
                                                                                {data.userPhoneReg}
                                                                            </td>
                                                                            <td className={'align-middle'}>
                                                                                {data.userEmail}
                                                                            </td>
                                                                            <td>
                                                                                <img
                                                                                    className={'w-[25px] cursor-pointer inline-block'}
                                                                                    src={IconRemove} onClick={() => {
                                                                                    fn_delSiteChrgrDataRow(data.userSeq);
                                                                                }}/>
                                                                            </td>
                                                                        </tr>
                                                                    ))


                                                                    : <tr>
                                                                        <td colSpan={5}>
                                                                            <div className="text-center">
                                                                                등록된 담당자가 없습니다.
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                            }

                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </Row>
                                            </Container>)
                                        ) : <div
                                            className="w-100 justify-content-center d-flex flex-column align-items-center py-2">
                                            <img src={iconNodata} alt="이미지" style={{width: '70px'}}/>
                                            <span className="bmc-text-font_secondary02 bmc-fw-5 mt-2">등록된 직영 업체가 없습니다.</span>
                                        </div>

                                }
                            </div>
                        </div>

                        <div className="bmc-modal-div">
                            <div className="div-header">
                                <div>협력업체 정보</div>
                                <BMCIconButton kind={'add'}
                                              onClick={() => fn_cmpnyModalOpen('C001005')}>추가</BMCIconButton>
                            </div>
                            <div className="div-body px-3">
                                {
                                    coprDataList.length > 0 ?
                                        coprDataList.map((corpData: any, idx: number) => (

                                            <Container className='bmc-box-form py-2 mt-2' key={idx}>
                                                <Row className="font-semibold">
                                                    <div
                                                        className="d-flex justify-content-between align-items-center w-100 bmc-font-SD mb-2">
                                                        {'협력업체 ' + (idx + 1)}
                                                        <BMCIconButton kind={'delete'} onClick={() => fn_deleteCmpnyData(corpData.companySeq, 'C001005')}>삭제</BMCIconButton>
                                                    </div>
                                                </Row>
                                                <hr/>
                                                <Row className="mt-1 mb-2">
                                                    <Col>
                                                        <span className="bmc-fw-5">회사명</span>
                                                        <BMCInput className="bmc-form input text-center"
                                                                 value={corpData.companyName}
                                                                 disabled={true}/>
                                                    </Col>
                                                    <Col>
                                                        <span className="bmc-fw-5">대표전화</span>
                                                        <BMCInput className="bmc-form input text-center"
                                                                 value={corpData.contactPhoneNo}
                                                                 disabled={true}/>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <div className="div-body">
                                                        <div
                                                            className='w-100 d-flex justify-content-end align-items-center mb-2'>
                                                            <BMCIconButton kind={'add'} onClick={() => fn_openMngrModal(corpData.companySeq, 'C001005')}>행추가</BMCIconButton>
                                                        </div>
                                                        <Table className="sub my-2 text-center">
                                                            <thead>
                                                            <tr className="table-secondary">
                                                                <th className="align-middle w-[10%]">No</th>
                                                                <th className="align-middle w-[20%]">직위</th>
                                                                <th className="align-middle w-[20%]">이름</th>
                                                                <th className="align-middle w-[20%]">핸드폰</th>
                                                                <th className="align-middle w-[20%]">이메일</th>
                                                                <th className="align-middle w-[10%]">삭제</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody id="wrkDclrRgst_siteTBody">
                                                            {
                                                                siteChrgrDataList.filter((data: any) => (corpData.companySeq == data.blngCmpnySeq)).length > 0 ?
                                                                    siteChrgrDataList.map((data: any, idx: number) => (
                                                                        corpData.companySeq == data.blngCmpnySeq &&
                                                                        <tr key={idx}>
                                                                            <td>{idx + 1}</td>
                                                                            <td className={'align-content-start'}>
                                                                                {data.position}
                                                                            </td>
                                                                            <td className={'align-content-start'}>
                                                                                {data.userName}
                                                                            </td>
                                                                            <td className={'align-middle'}>
                                                                                {data.userPhoneReg}
                                                                            </td>
                                                                            <td className={'align-middle'}>
                                                                                {data.userEmail}
                                                                            </td>
                                                                            <td>
                                                                                <img
                                                                                    className={'w-[25px] cursor-pointer inline-block'}
                                                                                    src={IconRemove} onClick={() => {
                                                                                    fn_delSiteChrgrDataRow(data.userSeq);
                                                                                }}/>
                                                                            </td>
                                                                        </tr>
                                                                    ))


                                                                    : <tr>
                                                                        <td colSpan={5}>
                                                                            <div className="text-center">
                                                                                등록된 담당자가 없습니다.
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                            }

                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </Row>
                                            </Container>)
                                        ) : <div
                                            className="w-100 justify-content-center d-flex flex-column align-items-center py-2">
                                            <img src={iconNodata} alt="이미지" style={{width: '70px'}}/>
                                            <span className="bmc-text-font_secondary02 bmc-fw-5 mt-2">등록된 감리단이 없습니다.</span>
                                        </div>

                                }
                            </div>
                        </div>*/}

            <div className="bmc-modal-div">
              <div className="div-header">작성정보</div>
              <div className="div-body px-3">
                <Table className="my-2 align-middle">
                  <tbody>
                    <tr>
                      <th style={{ width: "10%" }}>작성일</th>
                      <td style={{ width: "40%" }}>
                        <BMCInput
                          value={data?.regDate || currentDate}
                          name={"regDate"}
                          className={"form-control all-white"}
                          disabled={true}
                        />
                      </td>
                      <th style={{ width: "10%" }}>작성자</th>
                      <td style={{ width: "40%" }}>
                        <BMCInput
                          className={"form-control all-white"}
                          name={"rgstrNm"}
                          value={data?.rgstrNm || user.userName}
                          disabled={true}
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="py-2">
          <div className="flex justify-center w-100">
            <button
              className="bmc-btn pill l white me-3"
              onClick={fn_closeModal}
            >
              닫기
            </button>
            {user.authCode != "headRead" && (
              <button onClick={fn_registData} className="bmc-btn pill p">
                등록/수정
              </button>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SiteManageRgstModal;
